import { render, staticRenderFns } from "./ConnectInstagram.vue?vue&type=template&id=f18d45e0&scoped=true&"
import script from "./ConnectInstagram.vue?vue&type=script&lang=js&"
export * from "./ConnectInstagram.vue?vue&type=script&lang=js&"
import style0 from "./ConnectInstagram.vue?vue&type=style&index=0&id=f18d45e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18d45e0",
  null
  
)

export default component.exports